import { useQuery } from "@tanstack/react-query"
import { fetcher } from "../fetcher"
import type { PaymentRequestPaymentMethod } from "./useTransactionPaymentRequestAllowedMethods"

export type Amount = {
  value: number
  currencyCode: string
}

type Attachment = {
  id: string
  name: string
}

export type TransactionsPaymentRequestDetailsApiResponse = {
  externalPaymentRequestId: Amount
  amount: Amount
  cardAmount: Amount | null
  creationDate: string
  dueDate: string
  recipientName: string
  coveredFee: null | number
  recipientAddress: {
    streetNumberAndName: string
    apartmentNumber: string
    city: string
    zipCode: string
    state: string
    country: string
  }
  emailAddress: string
  attachments: Attachment[]
  transferId: string | null
  transferStatus: "Completed" | null
  debitAuth: {
    limit: number
  }
  paymentMethod: PaymentRequestPaymentMethod
  allowedPaymentMethods: PaymentRequestPaymentMethod[]
}

type HookParams = {
  paymentRequestId: string
}

export function useTransactionPaymentRequestDetails({ paymentRequestId }: HookParams) {
  return useQuery<TransactionsPaymentRequestDetailsApiResponse>({
    queryKey: [`paymentRequest/${paymentRequestId}`],
    queryFn: async () => {
      const response = await fetcher(
        `/Transaction/PaymentRequest/${paymentRequestId}`,
        {
          method: "GET",
        },
        {
          useAccessToken: true,
          doNotLogOutOn401: true,
        }
      )
      const responseJson = await response.json()

      return responseJson
    },
  })
}
